<template>
  <div id="global-scan" class="modal_pageview scan-modal slideup modelslideup">
    <div class="model-header" v-if="$route.query.isScanner !== 'scan'">
      <h2 @click="closeScanner"><span class="material-icons">
close
</span></h2>
    </div>
    <div class="modal-midbox">
      <div class="order-idbox">
        <div class="field-row" v-if="!isGlobalScanner">
          <label class="text-label">आर्डर आईडी</label>
          <input
            iType="text"
            name="orderId"
            value=""
            class="input-style"
            placeholder="ऑर्डर आईडी नंबर दर्ज करेंं"
            @input="getOrderIdFromInput"
          />
        </div>
      </div>
      <div class="scan_box">
        <div class="scan-msg">
          <p>QR कोड स्कैन करें</p>
        </div>
        <div class="glob-scanner">
          <!-- <v-quagga
            v-if="!bar_code"
            :multiple="false"
            :onDetected="getBarcode"
            :inputStream="{
              constraints: {
                width: 1280,
                /* height: 480 */
              },
            }"
            :singleChannel="false"
            :readerTypes="[
              'code_128_reader',
              'code_39_reader',
              'code_39_vin_reader',
              /* 'ean_reader',
              'code_39_reader',
              'ean_8_reader',
              'code_39_vin_reader',
              'codabar_reader',
              'upc_reader',
              'upc_e_reader',
              'i2of5_reader' */
            ]"
          /> -->
          <qrcode-stream v-if="isScannerOpen" @decode="getBarcode" @init="onInit" :camera="camera" />
          <!-- <div style="width: 500px" id="reader"></div> -->
          <!-- <qrcode-scanner
    :qrbox="250" 
    :fps="10" 
    style="width: 500px;"
    @result="getBarcode"
    :bus="bus"
  /> -->
  <!-- <button type="submit" @click.prevent="submit">Post</button> -->
        </div>

        <!-- <div class="process-ftr" v-if="orderId">
          <button class="button" @click="emitOrderId">Proceed</button>
        </div>

        <div class="scan-ftr" v-else>
          <button class="button" @click="closeScanner">
             स्कैन खत्म हो गया है 
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getMediaPermission } from "../utils/helper";
import { QrcodeStream } from 'vue-qrcode-reader'
// import QrcodeScanner from '../components/QrcodeScanner'
// import QrcodeScanner from './QrcodeScanner.vue';
import Vue from 'vue'
export default {
  props: ["isGlobalScanner"],
  components: {
    QrcodeStream,
    // QrcodeScanner
    // QrcodeScanner
  },
  data() {
    return {
      bar_code: false,
      orderId: "",
      error: '',
      bus: new Vue(),
      camera: 'auto',
      isScannerOpen:false
    };
  },

  methods: {
    onScan (qrCodeMessage) {
      // handle the message here :)
      console.log('-------')
// console.log(qrCodeMessage);
    },
    startFrontCamera () {
      this.camera = 'front'
    },
    submit() {
      this.bus.$emit('submit')
    },
    getOrderIdFromInput(_event) {
      if (_event.target.value) {
        this[_event.target.name] = _event.target.value;
      } else {
        this.bar_code = false;
        this[_event.target.name] = "";
      }
    },

    emitOrderId() {
      this.$emit("orderId", this["orderId"].trim());
    },

    getBarcode(data) {
      this.bar_code = data
      this.$emit("orderId", this.bar_code);
      // this.$router.push('/shipping-details')
    },

    closeScanner() {
      this.$emit("closeScanner");
    },
    async onInit (promise) {
      try {
        await promise
        promise.catch(error => {
        const cameraMissingError = error.name === 'OverconstrainedError'
        const triedFrontCamera = this.camera === 'front'

        if (triedFrontCamera && cameraMissingError) {
          // no front camera on this device
        }
      })
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
      
    }
  },
  async mounted() {
    // const html5QrCode = new Html5Qrcode("#reader");
    // const html5QrCode = new Html5Qrcode("#reader");
    // const qrCodeSuccessCallback = message => { / handle success / }
    // const config = { fps: 10, qrbox: 250 }
    // html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccessCallback);
    let _this = this;
    __native_money91.checkForPermissionResult = (result) => {
    if (result.length) {
      alert('कृपया कैमरा को  अनुमति दें');
      this.isScannerOpen = false
      this.closeScanner()
    }
    this.isScannerOpen=true;
  };
  // To allow JSbridge media permission
  const _ = ["android.permission.CAMERA"];
  try {
   return JSBridgePlugin.checkForPermission(
      _,
      true,
      "__native_money91.checkForPermissionResult"
    );
  } catch (err) {
    alert('एप्लिकेशन को सुचारू रूप से एक्सेस करने के लिए कृपया सभी मीडिया अनुमति प्रदान करेंं')
  }
    // document.querySelector('video')
    // const stream = await navigator.mediaDevices.getUserMedia({ deviceId: { exact: '6fbaa1bb7dea7a0141ee1d5d4009d9734dee1425aff82648b7a8adf4c433d64c' } });
    // const stream = await navigator.mediaDevices.getUserMedia({ video: {
    //   width: { min: 360, ideal: 640, max: 1920 },
    //   height: { min: 240, ideal: 480, max: 1080 },
    //    deviceId: { exact: '6fbaa1bb7dea7a0141ee1d5d4009d9734dee1425aff82648b7a8adf4c433d64c' } ,
    // }
    // });
    // videoEl.src = stream;
    // getMediaPermission(_this);
    
  },
};
</script>
<style lang="scss" scoped>
.qrcode-stream-camera{
  width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    -o-object-fit: contain;
    object-fit: contain;
    -o-object-position: top;
    object-position: top;
}
</style>